import { TypographySize } from 'mm-theme-configuration/dist/consts';
import { StyleSheet, StyleDeclarationValue, CSSProperties } from 'aphrodite/no-important';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';

type FontSizes = {
  fontSizeLarge: TypographySize
  fontSizeMedium: TypographySize
  fontSizeSmall: TypographySize
}
export interface SemanticTagDataProps{
  styles?: StyleDeclarationValue[]
  fontSizeLarge?: TypographySize
  fontSizeMedium?: TypographySize
  fontSizeSmall?: TypographySize
}

export type FontSizesStyles = {[key in TypographySize]: CSSProperties}

export interface SemanticTagThemeProps {
  fontSizesStyles: FontSizesStyles
}
export type SemanticTagProps = SemanticTagDataProps & SemanticTagThemeProps;

export const getStyleBySize = (fontSizesStyle: FontSizesStyles, fontSizes: FontSizes) => {
  const { fontSizeLarge, fontSizeMedium, fontSizeSmall } = fontSizes;
  return StyleSheet.create({
    tagStyle: {
      [MEDIA_BREAKPOINTS.LARGE]: {
        ...fontSizesStyle[fontSizeLarge],
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        ...fontSizesStyle[fontSizeMedium],
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        ...fontSizesStyle[fontSizeSmall],
      },
      margin: 0,
    },
  }).tagStyle;
};

export const semanticCSS = (...styles: StyleDeclarationValue[]) => styles;
